import actioniq from './actioniq.svg';
import acuityAds from './acuity-ads.svg';
import acxiom from './acxiom.svg';
import adMarketplace from './ad-marketplace.svg';
import adform from './adform.svg';
import adjust from './adjust.svg';
import adobeBdia from './adobe-bdia.svg';
import adobeEverestTech from './adobe-everest-tech.svg';
import adobeId from './adobe-id.svg';
import adroll from './adroll.svg';
import amazonDataFirehose from './amazon-data-firehose.svg';
import amazonDspCapi from './amazon-dsp-capi.svg';
import amazonKinesis from './amazon-kinesis.svg';
import amazonRedshiftV2 from './amazon-redshift.svg';
import amnet from './amnet.svg';
import amobee from './amobee.svg';
import amperity from './amperity.svg';
import amplitude from './amplitude.svg';
import appsFlyer from './apps-flyer.svg';
import attentive from './attentive.svg';
import awin from './awin.svg';
import applovin from './applovin.svg';
import bingAds from './bing-ads.svg';
import blob from './blob.svg';
import bloomreach from './bloomreach.svg';
import blueshift from './blueshift.svg';
import braze from './braze.svg';
import buildYourOwn from './build-your-own.svg';
import button from './button.svg';
import ceeId from './cee-id.svg';
import clinch from './clinch.svg';
import cm360 from './cm360.svg';
import commissionJunction from './commission-junction.svg';
import comscore from './comscore.svg';
import convert from './convert.svg';
import criteo from './criteo.svg';
import crossDomain from './cross-domain.svg';
import customIdentitySync from './custom-identity-sync.svg';
import customerIo from './customer-io.svg';
import databricks from './databricks.svg';
import engageFront from './engage-front.svg';
import epsilon from './epsilon.svg';
import eulerian from './eulerian.svg';
import facebookPixel from './facebook-pixel.svg';
import gcs from './gcs.svg';
import googleAdWords from './google-ad-words.svg';
import googleAdsSegments from './google-ads-segments.svg';
import googleAgentSearch from './google-agent-search.svg';
import googleAnalytics from './google-analytics.svg';
import googleAnalytics4Collect from './google-analytics-4-collect.svg';
import googleBigqueryStreaming from './google-bigquery-streaming.svg';
import googleCm360 from './google-cm360.svg';
import googleDataManager from './google-data-manager.svg';
import googleFirebase from './google-firebase.svg';
import googlePubsub from './google-pubsub.svg';
import googleTagManager from './google-tag-manager.svg';
import growthCode from './growth-code.svg';
import growthLoop from './growth-loop.svg';
import heap from './heap.svg';
import hightouch from './hightouch.svg';
import hubspotEvent from './hubspot-event.svg';
import impactRadius from './impact-radius.svg';
import inMarket from './in-market.svg';
import iterable from './iterable.svg';
import kafka from './kafka.svg';
import kargo from './kargo.svg';
import kochavaIdentitylink from './kochava-identitylink.svg';
import linkedinConversions from './linkedin-conversions.svg';
import lytics from './lytics.svg';
import magellanAi from './magellan-ai.svg';
import matomo from './matomo.svg';
import mediaMath from './media-math.svg';
import merkle from './merkle.svg';
import metarouter from './metarouter.svg';
import miqXandr from './miq-xandr.svg';
import mixpanel from './mixpanel.svg';
import molocoCommerceMedia from './moloco-commerce-media.svg';
import movableInk from './movable-ink.svg';
import movableInkCustomerData from './movable-ink-customer-data.svg';
import neustar from './neustar.svg';
import nextdoorCapi from './nextdoor-capi.svg';
import openaiCapi from './openai-capi.svg';
import optimizely from './optimizely.svg';
import partnerize from './partnerize.svg';
import perion from './perion.svg';
import pinterest from './pinterest.svg';
import pinterestCapi from './pinterest-capi.svg';
import podscribe from './podscribe.svg';
import podsights from './podsights.svg';
import qualtrics from './qualtrics.svg';
import rakutenConversions from './rakuten-conversions.svg';
import redditAds from './reddit-ads.svg';
import revJet from './rev-jet.svg';
import ringierAxelSpringerPoland from './ringier-axel-springer-poland.svg';
import roku from './roku.svg';
import roomvo from './roomvo.svg';
import rtbHouse from './rtb-house.svg';
import s3 from './s3.svg';
import salesforceCdp from './salesforce-cdp.svg';
import sasCi360 from './sas-ci-360.svg';
import snapchatCapi from './snapchat-capi.svg';
import snowflake from './snowflake.svg';
import spotifyCapi from './spotify-capi.svg';
import tapAd from './tap-ad.svg';
import tatari from './tatari.svg';
import teads from './teads.svg';
import thetradedeskConversionEvents from './thetradedesk-conversion-events.svg';
import thetradedeskDataAdvertiserFirstparty from './thetradedesk-data-advertiser-firstparty.svg';
import tiktok from './tiktok.svg';
import tradeDesk from './trade-desk.svg';
import treasureData from './treasure-data.svg';
import twitterConversions from './twitter-conversions.svg';
import uniphoreProfile from './uniphore-profile.svg';
import verizonMedia from './verizon-media.svg';
import videoamp from './videoamp.svg';
import wallaroo from './wallaroo.svg';
import wirtualnaPolska from './wirtualna-polska.svg';
import xAds from './x-ads.svg';
import xandr from './xandr.svg';
import yahooEnhancedAttribution from './yahoo-enhanced-attribution.svg';
import zeotap from './zeotap.svg';

const LOGO_MAP = {
  // A
  actioniq,
  acuityAds,
  'acuity-ads': acuityAds,
  acxiom,
  adMarketplace,
  'ad-marketplace': adMarketplace,
  adform,
  adjust,
  'adobe-analytics': adobeBdia,
  'adobe-bdia': adobeBdia,
  'adobe-experience-platform-interact': adobeBdia,
  adobe: adobeId,
  'adobe-id': adobeId,
  adobeEverestTech,
  adroll,
  'amazon-data-firehose': amazonDataFirehose,
  'amazon-dsp-capi': amazonDspCapi,
  'amazon-dsp-events': amazonDspCapi,
  'amazon-kinesis': amazonKinesis,
  'amazon-redshift-v2': amazonRedshiftV2,
  amnet,
  amobee,
  amperity,
  amperityProfile: amperity,
  amperityRTProfile: amperity,
  amplitude,
  'apps-flyer-android': appsFlyer,
  'apps-flyer-ios': appsFlyer,
  appsFlyer: appsFlyer,
  attentive,
  awin,
  axon: applovin,

  // B
  bing: bingAds,
  'bing-ads': bingAds,
  blob,
  bloomreach,
  blueshift,
  braze,
  'build-your-own': buildYourOwn,
  button,

  // C
  CM360: cm360,
  ceeId,
  clinch,
  commissionJunction,
  'commission-junction': commissionJunction,
  comscore,
  convert,
  criteo,
  crossDomain,
  customIdentitySync,
  customerIo,
  'customer-io': customerIo,

  // D
  'databricks-zerobus': databricks,

  // E
  engageFront,
  'engage-front': engageFront,
  epsilon,
  eulerian,

  // F
  'facebook-pixel': facebookPixel,
  facebookTag: facebookPixel,
  fetchSync: customIdentitySync,
  fpc: customIdentitySync,

  // G
  gcs,
  googleAds: googleAdWords,
  'google-ad-words': googleAdWords,
  'google-ads': googleAdWords,
  'google-ads-audience': googleAdWords,
  googleAdManager: googleTagManager,
  'google-agent-search': googleAgentSearch,
  'google-agent-search-retail': googleAgentSearch,
  googleAnalytics,
  googleAnalytics4: googleAnalytics4Collect,
  googleAnalyticsGtag: googleAnalytics4Collect,
  'google-analytics': googleAnalytics,
  'google-analytics-4': googleAnalytics4Collect,
  'google-analytics-4-collect': googleAnalytics4Collect,
  'google-bigquery-streaming': googleBigqueryStreaming,
  'google-cm360': googleCm360,
  'google-dm-audiences': googleDataManager,
  'google-dm-events': googleDataManager,
  googleFloodlight: googleCm360,
  'google-firebase': googleFirebase,
  'google-pubsub': googlePubsub,
  'google-tag-manager': googleTagManager,
  googleAdsSegments,
  googleGtag: googleAnalytics4Collect,
  googleGtagDeprecated: googleAnalytics4Collect,
  growthCode,
  growthLoop,

  // H
  heap,
  hightouch,
  hubSpotTag: hubspotEvent,
  hubspot: hubspotEvent,
  'hubspot-event': hubspotEvent,

  // I
  'impact-radius': impactRadius,
  inMarket,
  'in-market': inMarket,
  ipv4Lookup: metarouter,
  iterable,

  // K
  kafka,
  kargo,
  kochava: kochavaIdentitylink,
  'kochava-identitylink': kochavaIdentitylink,

  // L
  linkedIn: linkedinConversions,
  'linkedin-conversions': linkedinConversions,
  ls: customIdentitySync,
  lytics,

  // M
  'magellan-ai': magellanAi,
  matomo,
  matchPixel: customIdentitySync,
  mediaMath,
  'media-math': mediaMath,
  merkle,
  metarouter,
  microsoftAds: bingAds,
  'microsoft-ads': bingAds,
  'microsoft-ads-capi': bingAds,
  'miq-xandr': miqXandr,
  mixpanel,
  'moloco-commerce-media': molocoCommerceMedia,
  movableInk,
  movableInkCustomerData,
  'movable-ink': movableInk,
  'movable-ink-customer-data': movableInkCustomerData,

  // N
  neustar,
  nextdoor: nextdoorCapi,
  'nextdoor-capi': nextdoorCapi,

  // O
  'openai-capi': openaiCapi,
  openAI: openaiCapi,
  optimizely,

  // P
  partnerize,
  perion,
  pinterest,
  pinterestCapi,
  pinterestCAPI: pinterestCapi,
  pinterestV2: pinterest,
  'pinterest-capi': pinterestCapi,
  'pipeline-router': metarouter,
  podscribe,
  podsights,

  // Q
  qualtrics,

  // R
  rakuten: rakutenConversions,
  'rakuten-conversions': rakutenConversions,
  rasp: ringierAxelSpringerPoland,
  redditAds,
  'reddit-ads': redditAds,
  revjet: revJet,
  'rev-jet': revJet,
  ringierAxelSpringerPoland,
  'ringier-axel-springer-poland': ringierAxelSpringerPoland,
  roku,
  'roku-capi': roku,
  roomvo,
  rtbHouse,
  'rtb-house': rtbHouse,

  // S
  s3,
  'salesforce-cdp': salesforceCdp,
  'salesforce-marketing': salesforceCdp,
  'sas-ci-360': sasCi360,
  snapchat: snapchatCapi,
  snapchatCapi,
  snapchatCAPI: snapchatCapi,
  'snapchat-capi': snapchatCapi,
  snowflake,
  'snowflake-streaming': snowflake,
  'spotify-capi': spotifyCapi,

  // T
  tapAd,
  tatari,
  teads,
  'teads-capi': teads,
  teadsCAPI: teads,
  theTradeDesk: thetradedeskConversionEvents,
  'thetradedesk-conversion-events': thetradedeskConversionEvents,
  'thetradedesk-data-advertiser-firstparty': thetradedeskDataAdvertiserFirstparty,
  tiktok,
  'trade-desk': tradeDesk,
  'treasure-data': treasureData,
  'ttd-conversions': thetradedeskConversionEvents,
  'ttd-offline-conversions': thetradedeskConversionEvents,
  twitterConversion: twitterConversions,
  'twitter-conversions': twitterConversions,

  // U
  unifiedId2: thetradedeskConversionEvents,
  unifiedId2Token: thetradedeskConversionEvents,
  uniphoreProfile,
  'uniphore-profile': uniphoreProfile,
  urlParameters: customIdentitySync,

  // V
  verizon: verizonMedia,
  'verizon-media': verizonMedia,
  videoamp,

  // W
  wallaroo,
  wirtualnaPolska,
  'wirtualna-polska': wirtualnaPolska,

  // X
  xAds,
  'x-ads': xAds,
  xandr,

  // Y
  'yahoo-conversions-api': yahooEnhancedAttribution,
  yahooCAPI: yahooEnhancedAttribution,
  yahooMedia: yahooEnhancedAttribution,
  'yahoo-enhanced-attribution': yahooEnhancedAttribution,
  'yahoo-offline-conversion': yahooEnhancedAttribution,

  // Z
  zeotap,
};

export default LOGO_MAP;
